import React from "react";
import { siteDarkGreen } from "../../providers/Theme";
import MedicalAdvisoryBoardCard from "../../components/MedicalAdvisoryBoardCard";
import CindyBauer from "../../assets/medical-advisory-board/cindy-bauer.jpg";
import BentleyBobrow from "../../assets/medical-advisory-board/bentley-bobrow.jpg";
import BenWright from "../../assets/medical-advisory-board/ben-wright.jpg";
import { PageContainer, Header } from "../shared.styled.components";

const MedicalAdvisoryBoard: React.FC = () => {
  return (
    <PageContainer>
      <Header color={siteDarkGreen}>Medical Advisory Board</Header>

      <div className="d-flex flex-wrap justify-content-center pt-5">
        <MedicalAdvisoryBoardCard
          src={CindyBauer}
          title="Cindy Salm Bauer, MD, FAAAAI"
          content={[
            "Division Chief, Allergy and Immunology, Phoenix Children's Hospital",
            "Co‐Director, Eosinophilic Gastrointestinal Disease Clinic"
          ]}
        />
        <MedicalAdvisoryBoardCard
          src={BentleyBobrow}
          title="Bentley J. Bobrow, MD, FACEP, FAHA"
          content={[
            "Department of Emergency Medicine at the University of Arizona College of Medicine - Tucson",
            "Co‐director of EMS research",
            "Associate director of the Arizona Emergency Medicine Research Center"
          ]}
        />
        <MedicalAdvisoryBoardCard
          src={BenWright}
          title="Benjamin Wright"
          content={[
            "Consultant - Division of Allergy, Asthma, and Clinical Immunology, Mayo Clinic Arizona",
            "Physician - Division of Allergy and Immunology, Phoenix Children's",
            "Site Principal Investigator - Consortium of Eosinophilic Gastrointestinal Disease Researchers (CEGIR)",
            "Chair - Eosinophilic Gastrointestinal Disorders Subcommittee, American Academy of Allergy, Asthma, and Immunology (AAAAI)",
            "Clinical Assistant Professor of Child Health - Phoenix Children's",
            "Associate Professor of Medicine - Mayo Clinic Arizona"
          ]}
        />
      </div>
    </PageContainer>
  );
};

export default MedicalAdvisoryBoard;
